module.exports = __webpack_public_path__ + "static/media/icon-module-ciq-desktop.6f480be3.svg";